function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Heading, Icon, Stack, Text } from '@chakra-ui/react';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
var SONGS = [
    {
        id: uuidv4(),
        title: 'Rock',
        requester: 'jacksack',
        duration: '2:45',
        coverColor: 'blue.500'
    },
    {
        id: uuidv4(),
        title: 'Pop',
        requester: 'sauce',
        duration: '3:21',
        coverColor: 'purple.500'
    },
    {
        id: uuidv4(),
        title: 'Jazz',
        requester: 'Blakelund',
        duration: '4:20',
        coverColor: 'green.500'
    },
    {
        id: uuidv4(),
        title: 'Classical',
        requester: 'sorty96',
        duration: '7:23',
        coverColor: 'red.500'
    },
    {
        id: uuidv4(),
        title: 'Metal',
        requester: 'Teak',
        duration: '4:15',
        coverColor: 'yellow.500'
    }
];
export default function SongRequestPanel(props) {
    var _React_useState = _sliced_to_array(React.useState(SONGS), 2), songs = _React_useState[0], setSongs = _React_useState[1];
    var ref = React.useRef(null);
    var inView = useInView(ref);
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), isVisible = _React_useState1[0], setIsVisible = _React_useState1[1];
    function cycleSongs() {
        setSongs(function(prevSongs) {
            var _prevSongs = _to_array(prevSongs), first = _prevSongs[0], rest = _prevSongs.slice(1);
            var newFirst = _object_spread_props(_object_spread({}, first), {
                id: uuidv4()
            });
            return _to_consumable_array(rest).concat([
                newFirst
            ]);
        });
    }
    React.useEffect(function() {
        if (!inView || !isVisible) {
            return;
        }
        var interval = setInterval(cycleSongs, 4e3);
        return function() {
            return clearInterval(interval);
        };
    }, [
        inView,
        isVisible
    ]);
    React.useEffect(function() {
        var handleVisibilityChange = function handleVisibilityChange() {
            setIsVisible(document.visibilityState === 'visible');
        };
        handleVisibilityChange();
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function() {
            return document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return /*#__PURE__*/ _jsx(Stack, _object_spread_props(_object_spread({
        ref: ref,
        spacing: 0,
        marginX: 4,
        marginBottom: -12,
        marginTop: -10
    }, props), {
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "popLayout",
            initial: false,
            children: [
                songs[0],
                songs[1],
                songs[2]
            ].map(function(song, index) {
                return /*#__PURE__*/ _jsx(motion.div, {
                    layout: true,
                    initial: {
                        opacity: 0,
                        filter: "brightness(".concat(1 - index * 0.1, ")"),
                        scale: 0.9 + (songs.length - index) * 0.055,
                        zIndex: songs.length - index,
                        y: 0
                    },
                    animate: {
                        opacity: 1,
                        filter: "brightness(".concat(1 - index * 0.1, ")"),
                        scale: 0.9 + (songs.length - index) * 0.055,
                        zIndex: songs.length - index,
                        y: (index - 1) * -40
                    },
                    exit: {
                        opacity: 0,
                        scale: 0.75,
                        y: -100,
                        zIndex: 10
                    },
                    transition: {
                        duration: 2,
                        ease: 'easeInOut',
                        type: 'just',
                        stiffness: 200,
                        damping: 30
                    },
                    children: /*#__PURE__*/ _jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        padding: 2,
                        borderRadius: "xl",
                        backdropFilter: "blur(20px)",
                        bgColor: "gray.100",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faMusic,
                                color: "textPrimary",
                                bgGradient: "linear(to-br, ".concat(song.coverColor, ", blackAlpha.300)"),
                                bgColor: song.coverColor,
                                padding: 2,
                                size: "lg",
                                borderRadius: "lg"
                            }),
                            /*#__PURE__*/ _jsxs(Stack, {
                                spacing: 0,
                                ml: 3,
                                children: [
                                    /*#__PURE__*/ _jsx(Heading, {
                                        color: "textInverse",
                                        size: "xs",
                                        children: song.title
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "xs",
                                        color: "textInverse",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "HoFfVu",
                                            defaultMessage: "Requested by {requester}",
                                            values: {
                                                requester: song.requester
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                mr: 4,
                                ml: "auto",
                                fontSize: "xs",
                                color: "textInverse",
                                children: song.duration
                            })
                        ]
                    })
                }, song.id);
            })
        })
    }));
}
